import React from "react";
import { Link } from "react-router-dom";
import ServiceAreaSelect from "./../../User/Homepage/ServiceArea/ServiceAreaSelect";
import FooterSEO from "./FooterSEO";
import Icon from "../../UI/Icon";
import { Logo } from "../../UI/Primitives";
import * as endpoint from "../../../Service/endpoints";
import { NAV_CATEGORIES, getCategoryMeta } from "../../User/Catalog/categoryMeta";
import cityLandings from "../../../content/cityLandings.json";
import "./footer.css";

const POPULAR = [
  { label: "Sofa sets", q: "sofa" },
  { label: "Washing machines", q: "Washing machine" },
  { label: "Refrigerators", q: "Refrigerator" },
  { label: "Air coolers", q: "air cooler" },
  { label: "Televisions", q: "TV" },
  { label: "Microwaves", q: "Microwave" },
];

const SOCIAL = [
  { label: "Facebook", icon: "facebook", href: "https://www.facebook.com/Voorent.rentals" },
  { label: "LinkedIn", icon: "linkedin", href: "https://www.linkedin.com/company/voorent?originalSubdomain=in" },
  { label: "Instagram", icon: "instagram", href: "https://www.instagram.com/voorent/" },
];

function FooterComponent() {
  const year = new Date().getFullYear();

  return (
    <footer className="v-footer">
      {window.location.href.indexOf("medium=") < 0 && <ServiceAreaSelect />}

      <div className="v-container">
        <div className="v-footer__grid">
          <div className="v-footer__brand">
            <Logo height={26} />
            <p>
              Furniture and appliances on rent with flexible plans, doorstep delivery and set-up — we put your
              convenience before anything.
            </p>
            <a className="v-footer__mail" href="mailto:support@voorent.com">
              <Icon name="mail" size={18} /> support@voorent.com
            </a>
            <ul className="v-footer__social" aria-label="Voorent on social media">
              {SOCIAL.map((item) => (
                <li key={item.label}>
                  <a href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.label} className="v-icon-btn">
                    <Icon name={item.icon} size={20} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <nav className="v-footer__col" aria-label="Categories">
            <h2 className="v-footer__heading">Rent</h2>
            <ul>
              {NAV_CATEGORIES.map((slug) => (
                <li key={slug}>
                  <Link to={endpoint.getPath(slug)}>{getCategoryMeta(slug).short}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="v-footer__col" aria-label="Cities">
            <h2 className="v-footer__heading">Cities</h2>
            <ul>
              {cityLandings.combos.map((page) => (
                <li key={`${page.city}-${page.slug}`}>
                  <Link to={`/${page.city}/${page.slug}`}>
                    Furniture + appliances in {cityLandings.cities[page.city]}
                  </Link>
                </li>
              ))}
              {cityLandings.pages.map((page) => (
                <li key={`${page.city}-${page.slug}`}>
                  <Link to={`/${page.city}/${page.slug}`}>
                    {page.slug === "appliances" ? "Appliances" : "Furniture"} in {cityLandings.cities[page.city]}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="v-footer__col" aria-label="Popular rentals">
            <h2 className="v-footer__heading">Popular</h2>
            <ul>
              {POPULAR.map((item) => (
                <li key={item.q}>
                  <Link to={`/search/${encodeURIComponent(item.q)}`}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="v-footer__col" aria-label="Company">
            <h2 className="v-footer__heading">Company</h2>
            <ul>
              <li><Link to="/about-us">About us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/customization">Customization</Link></li>
              <li><Link to="/blogs/buying-vs-renting">Blog</Link></li>
              <li><a href="https://p2p.voorent.com/">List an item</a></li>
            </ul>
          </nav>

          <nav className="v-footer__col" aria-label="Legal">
            <h2 className="v-footer__heading">Legal</h2>
            <ul>
              <li><Link to="/privacy-policy">Privacy policy</Link></li>
              <li><Link to="/terms-conditions">Terms &amp; conditions</Link></li>
            </ul>
          </nav>
        </div>

        <div className="v-footer__seo">
          <FooterSEO />
        </div>

        <div className="v-footer__bottom">
          <span>© 2017–{year} Voorent Pvt. Ltd.™ All rights reserved.</span>
          <span className="v-footer__cities">
            <Icon name="pin" size={14} /> Serving Delhi, Gurgaon &amp; Noida
          </span>
        </div>
      </div>
    </footer>
  );
}

export default FooterComponent;
